// Registers the runtime-caching service worker (public/sw.js).
// Only active in production builds served over HTTPS (or localhost).
export function register() {
  if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) {
    return;
  }

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        // When a new SW is found, activate it on the next load.
        registration.addEventListener("updatefound", () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.addEventListener("statechange", () => {
            if (installing.state === "installed" && navigator.serviceWorker.controller) {
              // A new version is ready; it will take over on the next navigation.
              installing.postMessage?.("SKIP_WAITING");
            }
          });
        });
      })
      .catch(() => {
        /* registration failures are non-fatal */
      });
  });
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready.then((r) => r.unregister()).catch(() => {});
  }
}
